import { useState } from 'react';
import { placeBidOnLocalCarLive } from '../../services/localCarsService';

const usePlaceBidLocalCarLive = () => {
  const [bidData, setBidData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [placeBidSuccess, setPlaceBidSuccess] = useState(false);

  const resetBidState = () => {
    setError(null);
    setPlaceBidSuccess(false);
  };

  const handlePlaceBidLocalCarLive = async (localCarID, currentBid, type) => {
    setLoading(true);
    try {
      const response = await placeBidOnLocalCarLive(localCarID, currentBid, type);
      setBidData(response);
      setPlaceBidSuccess(true);
    } catch (err) {
      if (err.response) {
        setError(`${err.response.data.message || 'No response from server'}`);
      } else if (err.request) {
        setError('No response from server');
      } else {
        setError(`${err.message || 'No response from server'}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return { bidData, loading, error, handlePlaceBidLocalCarLive, placeBidSuccess, resetBidState };
};

export default usePlaceBidLocalCarLive;
